module.exports = __webpack_public_path__ + "static/media/isae_logo.f17398ed.png";